// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__3zTzh","item":"styles_item__ObQZG"};